import { render, staticRenderFns } from "./AnnotationTypeGuaranteesDetailed.vue?vue&type=template&id=4e75d75a&scoped=true"
import script from "./AnnotationTypeGuaranteesDetailed.vue?vue&type=script&lang=js"
export * from "./AnnotationTypeGuaranteesDetailed.vue?vue&type=script&lang=js"
import style0 from "./AnnotationTypeGuaranteesDetailed.vue?vue&type=style&index=0&id=4e75d75a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e75d75a",
  null
  
)

export default component.exports